import React from "react";

const List = ({ children }) => {
  return <div className="zoneVideosOuter row">{children}</div>;
};

export default List;
